module.exports = __webpack_public_path__ + "static/media/traiteur-2.fa3bbe81.jpg";